import * as React from 'react';
import { ProductMenuItem } from '../../store/productSlice';
import MainMenuPopover from './menu_popover';

const MainMenuItem: React.FC<ProductMenuItem> = ({ ...productMenuItem }) => {
  return (
    <MainMenuPopover productMenuItem={productMenuItem}  />
  );
}

export default MainMenuItem;


/*

                  <MenuItem onClick={handleClose}>
            <Card key={index}  onClick={(e) => handleStyleSelection(e, index, cardItem.name)}>                      
                <Link to="#">
                        {
                          cardItem.hexaCode ? 
                          <CardContent>
                            <div style={{height: "50px", width: "50px", backgroundColor: `${cardItem.hexaCode}`  }}></div>
                          </CardContent> :
                        
                        <CardHeader title={<CardMedia
                                component="img"
                                image={cardItem.image}
                                height="150"
                            />}></CardHeader>

                          }
                        <span className="style-cards-title">{cardItem.displayName || cardItem.name}</span>
                            
                </Link>
            </Card>
                  </MenuItem> 

*/


/*

              
                <Card sx={{maxHeight : 120, maxWidth : 150}}  key={index} onClick={(e) => handleStyleSelection(e, index, cardItem.name)}>
                  <Link to="#">
                    {
                      cardItem.hexaCode ?
                        <CardContent>
                          <div style={{ height: "64px", width: "64px", backgroundColor: `${cardItem.hexaCode}` }}></div>
                          <div className="style-cards-title">{cardItem.displayName || cardItem.name}</div>
                        </CardContent> :
                        <div>
                          <CardHeader title={<CardMedia
                            component="img"
                            image={cardItem.image}
                            height="100"
                          />}></CardHeader>
                          <CardContent>
                            <div className="style-cards-title">{cardItem.displayName || cardItem.name}</div>
                          </CardContent>
                        </div>

                    }
                    
                  </Link>
                </Card>


*/